import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { getPlannedProducts } from '../../services/internal/associate-products-service'

export const fetchPlannedProductsAction = createAsyncThunk(
  'associateProducts/fetchProducts',
  async (data: { eventId; productStatus; request }) => {
    const { eventId, productStatus, request } = data
    return await getPlannedProducts({ eventId, productStatus, request })
  },
)

const initialState = {
  plannedProducts: [],
  isFetchingPlannedProducts: false,
}

const associateProductsSlice = createSlice({
  name: 'associateProducts',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(fetchPlannedProductsAction.pending, state => {
        state.isFetchingPlannedProducts = true
      })
      .addCase(fetchPlannedProductsAction.fulfilled, (state, action) => {
        state.plannedProducts = action.payload.data
        state.isFetchingPlannedProducts = false
      })
      .addCase(fetchPlannedProductsAction.rejected, state => {
        state.plannedProducts = []
        state.isFetchingPlannedProducts = false
      })
  },
})

export default associateProductsSlice.reducer
